<p>
  <span
    [innerHtml]="(fullIntroText ? fullTextHtml : shortTextHtml) | translate | safeHtml"
  ></span>
  <a class="nav-cell" (click)="fullIntroText = !fullIntroText">
    {{ (fullIntroText ? 'common_show_less' : 'common_show_more') | translate }}</a
  >
</p>